import ArrowCircleDownRoundedIcon from "@mui/icons-material/ArrowCircleDownRounded";
import { Box, Chip, Collapse, IconButton, Typography } from "@mui/material";
import React, { Fragment, useEffect, useRef } from "react";
import ChatBotDownArrowIco from "../../assets/icons/ChatBotDownArrowIco";
import ChatBotInputIco from "../../assets/icons/ChatBotInputIco";
import ChatBotUpArrowIco from "../../assets/icons/ChatBotUpArrowIco";
import Ellipse from "../../assets/icons/Ellipse";
import GeminiIco from "../../assets/icons/GeminiIco";
import HaileyChatBotIco from "../../assets/icons/HaileyChatBotIco";
import HaileyCollapseIco from "../../assets/icons/HaileyCollapseIco";
import HaileyExpandIco from "../../assets/icons/HaileyExpandIco";
import XCloseIco from "../../assets/icons/XCloseIco";
import { ReactComponent as JobRightNavIcon } from "../../assets/images/JobRightNavIcon.svg";
import { ReactComponent as RightbarSupport } from "../../assets/images/RightbarSupport.svg";
import CommonButton from "../../component/Button";
import CommonTextField from "../../component/Input";
import { CommonGrid2 } from "../common-components/StyledComponents";
import { CommonTippy, CustomizeSpan } from "../jobs/style";
import {
  CustomDiv,
  CustomMarkDown,
  HaileyButton,
  WholePageEllipse,
  WholePageOpacity,
} from "./style";

export default function SideBarChatBot({
  handleToggleDrawer,
  chatBotData,
  isBottomVisible,
  setIsBottomVisible,
  handleButtonClickByLabel,
  handleUpArrow,
  handleChatBotChange,
  handleSendMessage,
  userName,
  buttonSupport,
  handleButtonSupport,
  chatBotPlaceholder,
  title,
  description,
  handleActivityChange,
  minimizeButton = true,
  handleExpandDrawer,
}) {
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  };

  const handleIconClick = () => {
    handleSendMessage();
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatBotData.message]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsBottomVisible(entry.isIntersecting);
      },
      { threshold: 1.0 }
    );

    if (messagesEndRef.current) {
      observer.observe(messagesEndRef.current);
    }

    return () => {
      if (messagesEndRef.current) {
        observer.unobserve(messagesEndRef.current);
      }
    };
  });

  return (
    <Fragment>
      <Fragment>
        {minimizeButton && (
          <CommonGrid2
            display={"flex"}
            flexWrap={"wrap"}
            alignItems={"center"}
            justifyContent={"space-between"}
            padding={"0.5rem 0px 0.8rem"}
          >
            <CommonGrid2 display={"flex"} gap={"4px"}>
              <HaileyChatBotIco />
              <Typography variant="h5" color="#101828">
                Hailey
              </Typography>
            </CommonGrid2>
            <CommonGrid2 display={"flex"} gap={"5px"} alignItems={"center"}>
              <CommonTippy
                content={chatBotData.expandDrawer ? "Collapse" : "Expand"}
                placement="top"
                color={"#7F56D9"}
                fontSize="11px"
              >
                <HaileyButton onClick={handleExpandDrawer} padding="0px">
                  {chatBotData.expandDrawer ? (
                    <HaileyCollapseIco />
                  ) : (
                    <HaileyExpandIco />
                  )}
                </HaileyButton>
              </CommonTippy>
              <CommonTippy
                content="Close"
                placement="top"
                color={"#7F56D9"}
                fontSize="11px"
              >
                <HaileyButton onClick={handleToggleDrawer} padding="0px">
                  <XCloseIco size={"22px"} />
                </HaileyButton>
              </CommonTippy>
            </CommonGrid2>
          </CommonGrid2>
        )}
        <Typography
          variant="h3"
          color="#8396A8"
          fontWeight={700}
          sx={{
            background: "linear-gradient(149deg, #5A35B2 3.87%, #FA4F96 40%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
          marginBottom={"5px"}
        >
          {title ? (
            title
          ) : (
            <>
              Hello{" "}
              <CustomizeSpan color="#6941C6" textTransform="capitalize">
                {userName}
              </CustomizeSpan>
            </>
          )}
        </Typography>
        <Typography variant="body5" color="#8396A8">
          {description ? description : "How can I help you ?"}
        </Typography>
        {chatBotData?.geminiBubble &&
          chatBotData?.geminiBubble?.length !== 0 && (
            <Fragment>
              <Box sx={{ flexGrow: 1 }}>
                <Collapse
                  in={chatBotData.details === "Hide Details"}
                  timeout={400}
                  unmountOnExit
                >
                  <CommonGrid2
                    display={"flex"}
                    gap={"10px"}
                    flexDirection={"column"}
                    marginTop={"1rem"}
                  >
                    {chatBotData.geminiBubble.map((item) => (
                      <CommonButton
                        startIcon={<GeminiIco />}
                        value={item.question}
                        width={"100%"}
                        variant="outlined"
                        border={" #EAECF0"}
                        color="#101828"
                        borderRadius="7px"
                        padding={"8px 10px"}
                        gap={"0px"}
                        customStyle={{
                          justifyContent: "start",
                        }}
                        disabled={chatBotData.pageLoader || chatBotData.loader}
                        onClick={() => handleButtonClickByLabel(item)}
                      />
                    ))}
                  </CommonGrid2>
                </Collapse>

                <CommonButton
                  value={chatBotData.details}
                  width={"max-content"}
                  background={"transparent"}
                  boxShadow={"none"}
                  color="#6941C6"
                  padding={"10px 0px 0px"}
                  customStyle={{
                    "&:hover": {
                      boxShadow: "none",
                    },
                  }}
                  disabled={chatBotData.pageLoader || chatBotData.loader}
                  onClick={handleActivityChange}
                />
              </Box>
            </Fragment>
          )}

        <CommonGrid2
          size="12"
          height={"calc(100% - 3rem)"}
          overflowY={chatBotData.pageLoader ? "none" : "auto"}
          // marginTop={!chatBotData?.geminiBubble?.length && "10px"}
          marginTop={"10px"}
          width={"calc(100% + 26px)"}
          scrollStyle={chatBotData.pageLoader ? false : true}
          position={"relative"}
          left={"-10px"}
          scrollBar="6px"
        >
          {chatBotData.pageLoader && (
            <CustomDiv>
              <WholePageEllipse>
                <Ellipse />
              </WholePageEllipse>
              <WholePageOpacity></WholePageOpacity>
            </CustomDiv>
          )}

          <CommonGrid2 padding="10px 5px">
            {chatBotData.message.map((msg, index) => {
              if (!msg?.sender) return null;
              return (
                <div
                  key={index}
                  style={{
                    textAlign: msg.sender === "user" ? "right" : "left",
                    margin: "10px 0",
                  }}
                >
                  <Typography
                    fontSize={"13px"}
                    textAlign={"left"}
                    style={{
                      display: "inline-block",
                      padding:
                        msg.sender === "user" || msg.sender === "error"
                          ? "5px 10px"
                          : "0px",
                      backgroundColor:
                        msg.sender === "user"
                          ? "#7F56D9"
                          : msg.sender === "error"
                          ? "red"
                          : "#fff",
                      color:
                        msg.sender === "user" || msg.sender === "error"
                          ? "#fff"
                          : "#000",
                      borderRadius:
                        msg.sender === "user"
                          ? "8px 8px 1px 8px"
                          : "8px 8px 8px 1px",
                      maxWidth: msg.sender === "user" ? "80%" : "99%",
                      wordBreak: "break-word",
                      boxShadow:
                        msg.sender === "user"
                          ? "1px 1px 5px 1px rgb(16 24 40 / 11%)"
                          : "none",
                    }}
                  >
                    <CustomMarkDown>
                      {typeof msg.text === "string"
                        ? msg.text.trim()
                        : JSON.stringify(msg.text)}
                    </CustomMarkDown>
                  </Typography>
                </div>
              );
            })}

            {chatBotData.loader && (
              <CustomDiv position={"relative"}>
                <Ellipse />
              </CustomDiv>
            )}
            <div ref={messagesEndRef} />
          </CommonGrid2>
        </CommonGrid2>
        {!isBottomVisible && (
          <CustomDiv position={"relative"}>
            <IconButton
              onClick={scrollToBottom}
              style={{
                color: "#7F56D9",
                position: "absolute",
                left: "46.25%",
                background: "#fff",
                borderRadius: "50%",
                top: "-3rem",
                zIndex: 999,
                padding: "0px",
              }}
            >
              <ArrowCircleDownRoundedIcon style={{ fontSize: "25px" }} />
            </IconButton>
          </CustomDiv>
        )}
      </Fragment>

      {chatBotData.bubbleCondition && chatBotData?.bubble && (
        <CustomDiv position="relative" zIndex={999} textAlign="center">
          {chatBotData.arrow ? (
            <IconButton
              sx={{
                textAlign: "center",
                margin: "0px 0px -5px 0px",
                position: "absolute",
                width: "100%",
                top: "-1.2rem",
                padding: "0px",
                left: "0px",
                "&:hover": {
                  padding: "0px",
                  background: "transparent !important",
                },
              }}
              disabled={chatBotData.loader}
              onClick={() => handleUpArrow("up")}
            >
              <ChatBotUpArrowIco />
            </IconButton>
          ) : (
            <CustomDiv
              textAlign="center"
              width="94%"
              position="absolute"
              bottom="0px"
              transform="translate(14px, 0px)"
            >
              <IconButton
                sx={{
                  textAlign: "center",
                  margin: "0px 0px -0.6rem",
                  padding: "0px",
                  "&:hover": {
                    padding: "0px",
                    background: "transparent !important",
                  },
                }}
                onClick={() => handleUpArrow("down")}
              >
                <ChatBotDownArrowIco />
              </IconButton>
              <CustomDiv
                background="#fff"
                borderRadius="5px 5px 0px 0px"
                padding="1rem 10px 10px"
                boxShadow={"1px 1px 5px 1px rgb(16 24 40 / 11%)"}
              >
                <CommonGrid2
                  display="flex"
                  flexWrap="wrap"
                  justifyContent="center"
                  alignItems="center"
                  gap="10px"
                >
                  {chatBotData.bubble.map((item) => (
                    <Chip
                      label={item.question}
                      variant="outlined"
                      style={{
                        color: "#7F56D9",
                        borderRadius: "7px",
                        border: "1px solid #7F56D9 ",
                        fontSize: "12px",
                      }}
                      onClick={() => handleButtonClickByLabel(item)}
                    />
                  ))}
                </CommonGrid2>
              </CustomDiv>
            </CustomDiv>
          )}
        </CustomDiv>
      )}

      {buttonSupport && (
        <CommonGrid2 container margin={"10px 0px 0px"} spacing={1}>
          {buttonSupport.map((item) => (
            <CommonButton
              value={item.name}
              startIcon={item.icon}
              variant="outlined"
              color="#344054"
              border={
                chatBotData.selectedValue === item.name
                  ? "transparent"
                  : "#D0D5DD"
              }
              gap="8px"
              borderRadius={"5px"}
              disabled={chatBotData.loader || chatBotData.pageLoader}
              onClick={() => handleButtonSupport(item.name)}
              padding={"2px 10px"}
              fontSize={"13px"}
              background={
                chatBotData.selectedValue === item.name ? "#EBE1F9" : "#fff"
              }
              fontWeight={
                chatBotData.selectedValue === item.name ? "600" : "500"
              }
              customStyle={{
                "& .MuiButton-icon": {
                  margin: "0px",
                },
                "&:hover": {
                  background: "#EBE1F9",
                },
              }}
            />
          ))}
        </CommonGrid2>
      )}
      <CommonGrid2 margin={"10px 0px 5px"} display="flex">
        <CommonTextField
          datePickerCalender
          multiline
          rows={3}
          backgroundColor="#fff"
          padding={"0px"}
          value={chatBotData.value}
          fontSize="14px"
          placeholder={chatBotPlaceholder || "Ask Hailey anything.."}
          calenderIcon={<ChatBotInputIco color="#7F56D9" />}
          handleIconClick={handleIconClick}
          placeholderFontSize="14px"
          onChange={handleChatBotChange}
          disabled={chatBotData.loader || chatBotData.pageLoader}
          customStyle={{
            "& .MuiInputBase-root": {
              padding: "12px",
            },
          }}
        />
        <IconButton
          onClick={handleToggleDrawer}
          sx={{
            position: "relative",
            left: "10px",
            padding: "0px",
            "&:hover": {
              padding: "0px",
              boxShadow: "none",
              backgroundColor: "transparent !important",
            },
          }}
        >
          {chatBotData.selectedValue === "Candidate" ||
          chatBotData.selectedValue === "Job" ? (
            <JobRightNavIcon />
          ) : (
            <RightbarSupport />
          )}
        </IconButton>
      </CommonGrid2>
      <Typography fontSize={"10px"} textAlign={"center"}>
        Your agency’s chats are never used to train other agencies’ models.
        Hailey may occasionally make mistakes,{" "}
        <a
          href={`${process.env.REACT_APP_WEBSITE_URL}/terms-and-condition`}
          target="_blank"
          rel="noopener noreferrer"
        >
          so please review all information.
        </a>
      </Typography>
    </Fragment>
  );
}
